import compact from 'lodash/compact'

/**
 * Traverse the category tree, hydrating any categories that have guide IDs
 * but no guides with the guide objects from the categoryGuides map.
 */
export const transformCategoryTreeGuides = (categories, categoryGuides) => {
  if (categoryGuides === null) {
    return categories
  }

  return categories.map((category) => {
    let { guides } = category
    if (category.guideIds?.length && !guides) {
      guides = compact(
        category.guideIds.map((guideId) => categoryGuides[guideId])
      )
    }

    return {
      ...category,
      guides,
      children: transformCategoryTreeGuides(category.children, categoryGuides),
    }
  })
}
